export const KEY_USER_ACCESS_TOKEN = 'access_token';
export const KEY_USER_INFO = 'users';
export const KEY_MOBILE_NO = 'mobileNumber';